var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88564 11.6889C7.19334 11.0735 7.94166 10.8241 8.55706 11.1318C8.75797 11.2323 8.92722 11.3848 9.04782 11.5723L9.1142 11.6889L14.8683 23.1972C15.176 23.8126 14.9266 24.5609 14.3112 24.8686C14.1814 24.9335 14.0417 24.975 13.8984 24.9917L13.754 25.0001H2.24581C1.55777 25.0001 1 24.4423 1 23.7543C1 23.6093 1.02533 23.4657 1.07448 23.33L1.13152 23.1972L6.88564 11.6889ZM8.04747 12.0049C7.96279 11.9881 7.87484 12.0174 7.81714 12.0816L7.78006 12.1362L2.02595 23.6444C2.00888 23.6785 2 23.7161 2 23.7543C2 23.8707 2.08085 23.9681 2.18944 23.9936L2.24581 24.0001H13.754C13.7922 24.0001 13.8298 23.9912 13.864 23.9742C13.9651 23.9236 14.0162 23.8126 13.9953 23.7067L13.9739 23.6444L8.21977 12.1362C8.20392 12.1044 8.18149 12.0767 8.1542 12.0547L8.10985 12.0262L8.04747 12.0049ZM7.99992 21.5001C8.27606 21.5001 8.49992 21.724 8.49992 22.0001C8.49992 22.2763 8.27606 22.5001 7.99992 22.5001C7.72378 22.5001 7.49992 22.2763 7.49992 22.0001C7.49992 21.724 7.72378 21.5001 7.99992 21.5001ZM7.99992 15.5001C8.24538 15.5001 8.44953 15.677 8.49186 15.9102L8.49992 16.0001V20.1408C8.49992 20.417 8.27606 20.6408 7.99992 20.6408C7.75446 20.6408 7.55031 20.4639 7.50797 20.2307L7.49992 20.1408V16.0001C7.49992 15.724 7.72378 15.5001 7.99992 15.5001Z",
    fill: "#662B0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.b614e9d7b66feb618ed4d377cb0824ae.svg";
export { ForwardRef as ReactComponent };